import HttpService from './http.service.js'

class GrileService {
  async best() {
    const startOfToday = new Date()
    startOfToday.setHours(0, 0, 0, 0)
    const timestamp = startOfToday.getTime() / 1000

    const bestGrilaEndpoint = 'grile/best?today_timestamp=' + timestamp
    return HttpService.get(bestGrilaEndpoint)
  }

  async closeBestSession() {
    const closeBestSessionEndpoint = 'grile/close-best-session'
    return HttpService.post(closeBestSessionEndpoint)
  }

  async history() {
    const historyEndpoint = 'grile/history'
    return HttpService.get(historyEndpoint)
  }

  async subjectHistory() {
    const subjectHistoryEndpoint = 'grile/subject/history'
    return HttpService.get(subjectHistoryEndpoint)
  }

  async getSubject() {
    const getSubjectEndpoint = 'grile/subject'
    return HttpService.get(getSubjectEndpoint)
  }

  async getNextSimulare() {
    const getNextSimulareEndpoint = 'grile/next_simulare'
    return HttpService.get(getNextSimulareEndpoint)
  }

  async getNewSubject(subject_id, subject_code, similar_to) {
    let getNewSubjectEndpoint = 'grile/new_subject?subject_id=' + subject_id

    if (subject_code !== undefined) {
      getNewSubjectEndpoint += '&subject_code=' + subject_code
    }

    if (similar_to !== undefined) {
      getNewSubjectEndpoint += '&similar_to=' + similar_to
    }

    return HttpService.get(getNewSubjectEndpoint)
  }

  async createSubject(grile, code, allowHint) {
    const createSubjectEndpoint = 'grile/create_subject'
    return HttpService.post(createSubjectEndpoint, {
      grile: grile,
      code: code,
      allow_hint: allowHint,
    })
  }

  async newBest(
    filters,
    grileTypes,
    solving_mode,
    min_difficulty = 0,
    max_difficulty = 1,
    min_difficulty2 = 0,
    max_difficulty2 = 1,
  ) {
    const searchParams = new URLSearchParams({
      filters: filters,
      solving_mode: solving_mode,
      min_difficulty: min_difficulty,
      max_difficulty: max_difficulty,
      min_difficulty2: min_difficulty2,
      max_difficulty2: max_difficulty2,
      single_choice: grileTypes?.find(type => type.id === 'single')?.checked,
      multiple_choice: grileTypes?.find(type => type.id === 'multiple')
        ?.checked,
    })
    const newBestGrilaEndpoint = `grile/new_best?${searchParams.toString()}`
    return HttpService.get(newBestGrilaEndpoint)
  }

  async skip(
    filters,
    grileTypes,
    solving_mode,
    min_difficulty = 0,
    max_difficulty = 1,
    min_difficulty2 = 0,
    max_difficulty2 = 1,
  ) {
    const multiple_choice = grileTypes.find(
      type => type.id === 'multiple',
    )?.checked
    const single_choice = grileTypes.find(type => type.id === 'single')?.checked
    const searchParams = new URLSearchParams({
      filters: filters,
      solving_mode: solving_mode,
      multiple_choice: multiple_choice,
      single_choice: single_choice,
      min_difficulty: min_difficulty,
      max_difficulty: max_difficulty,
      min_difficulty2: min_difficulty2,
      max_difficulty2: max_difficulty2,
    })
    const skipGrilaEndpoint = `grile/skip?${searchParams.toString()}`
    return HttpService.get(skipGrilaEndpoint)
  }

  async create(payload) {
    const createGrilaEndpoint = 'grile/create'
    return HttpService.post(createGrilaEndpoint, payload)
  }

  async indent(payload) {
    const indentCodeEndpoint = 'grile/indent_code'
    return HttpService.post(indentCodeEndpoint, payload)
  }

  async getAllFilters() {
    const getAllFiltersEndpoint = 'grile/filters'
    return HttpService.get(getAllFiltersEndpoint)
  }

  async getAllTags() {
    const getAllTagsEndpoint = 'grile/all_tags'
    return HttpService.get(getAllTagsEndpoint)
  }

  async getAllSources() {
    const getAllSourcesEndpoint = 'grile/sources'
    return HttpService.get(getAllSourcesEndpoint)
  }

  async getAllFaculties() {
    const getAllFacultiesEndpoint = 'grile/faculties'
    return HttpService.get(getAllFacultiesEndpoint)
  }

  async submit(payload) {
    const submitGrilaEndpoint = 'grile/answer'
    return HttpService.post(submitGrilaEndpoint, payload)
  }

  async submitSubject(payload) {
    const submitSubjectEndpoint = 'grile/subject/answer'
    return HttpService.post(submitSubjectEndpoint, payload)
  }

  async grilaWithId(id) {
    const loadGrilaEndpoint = 'grile/load?grilaId=' + id
    return HttpService.get(loadGrilaEndpoint)
  }

  async nextGrila(id) {
    const nextGrilaEndpoint = 'grile/next?current=' + id
    return HttpService.get(nextGrilaEndpoint)
  }

  async prevGrila(id) {
    const prevGrilaEndpoint = 'grile/prev?current=' + id
    return HttpService.get(prevGrilaEndpoint)
  }

  async getHint(id) {
    const getHintEndpoint = 'grile/hint?grilaId=' + id
    return HttpService.get(getHintEndpoint)
  }

  async reportGrila(payload) {
    const reportGrilaEndpoint = 'grile/report'
    return HttpService.post(reportGrilaEndpoint, payload)
  }

  async getReports() {
    const getReportsEndpoint = 'grile/reports'
    return HttpService.get(getReportsEndpoint)
  }

  async rate(payload) {
    const getReportsEndpoint = 'grile/rate'
    return HttpService.post(getReportsEndpoint, payload)
  }

  async getClasament(faculty, period, course) {
    let getClasamentEndpoint = `grile/clasament?faculty=${faculty}&period=${period}&course=${course}`
    return HttpService.get(getClasamentEndpoint)
  }

  async addComment(payload) {
    const addCommentEndpoint = 'grile/comment'
    return HttpService.post(addCommentEndpoint, payload)
  }

  generateGrila = async payload => {
    const generateGrilaEndpoint = 'grile/generate-grila'
    return await HttpService.post(generateGrilaEndpoint, payload)
  }

  copyFromSource = async payload => {
    const copyFromSourceEndpoint = 'grile/copy-source'
    return await HttpService.post(copyFromSourceEndpoint, payload)
  }

  uploadFile = async payload => {
    const uploadFileEndpoint = 'grile/upload-file'
    return await HttpService.post(uploadFileEndpoint, payload)
  }

  skipSubject = async payload => {
    const skipSubjectEndpoint = 'grile/subject/skip'
    return await HttpService.get(skipSubjectEndpoint, payload)
  }

  saveGrid = async payload => {
    const saveGridEndpoint = 'grile/save_grila'
    return await HttpService.post(saveGridEndpoint, payload)
  }

  removeSavedGrid = async payload => {
    const removeSavedGridEndpoint = 'grile/remove_saved_grila'
    return await HttpService.post(removeSavedGridEndpoint, payload)
  }

  getSavedGrids = async payload => {
    const getSavedGridsEndpoint = 'grile/saved_grile'
    return await HttpService.get(getSavedGridsEndpoint, payload)
  }

  updateNote = async payload => {
    const updateNoteEndpoint = 'grile/update_note'
    return await HttpService.post(updateNoteEndpoint, payload)
  }

  getAllBooks = async payload => {
    const getALlBooksEndpoint = 'grile/all_books'
    return await HttpService.get(getALlBooksEndpoint, payload)
  }
}

export default new GrileService()
